import React from "react";
import styles from "../Block.module.css";

const DateBlock = ({ date = "", title = "" }) => (
	<div className={styles.container}>
		<div className={`${styles.title} ${styles.date__title}`}>{title}</div>
		<div>{date}</div>
	</div>
);

export default DateBlock;
